<template>
    <main :class="mainClass" class="d-flex flex-column min-h-100vh">
        <header class="header" id="header">
            <open-order-bar />
            <search-profile-modal v-if="isUrl(route('nl.employeedashboard.dashboard'))"/>
            <DemoBar/>
            <div class="bg-warning p-2" v-if="$page.props.auth.authorizedFromAdmin">
                <inertia-link class="no-underline" :href="route('nl.employeedashboard.logout')">
                    <div class="font-size-12 color-dark-blue px-0">
                        <i class="fa fa-user"></i>
                        <strong class="font-poppins font-weight-bold pr-3 pl-1 pt-1">
                            {{ Lang.get('employeedashboard::shared.authorized_as', {
                            'adminFullName' : $page.props.auth.authorizedFromAdmin.fullname,
                            'companyRepresentativeFullName' : $page.props.auth.user.fullname,
                        }) }}
                        </strong>
                    </div>
                </inertia-link>
            </div>
            <top-nav :url="url()"></top-nav>
        </header>
        <article class="d-flex flex-1-custom px-0" :class="containerized ? 'container' : ''">
            <slot />
        </article>
        <footer class="footer" id="footer">
            <div class="container">
                <nav class="nav float-left">
                    <a :href="$page.props.config.link_to_terms_and_conditions"
                    class="nav-link color-light-blue font-aileron-bold font-size-12 py-0">
                    {{ Lang.get('generic.terms_and_conditions') }}</a>
                    <inertia-link class="nav-link color-light-blue font-aileron-bold font-size-12 py-0" :href="route('nl.employeedashboard.logout')">{{ Lang.get('employeedashboard::shared.layout.footer.logout') }}</inertia-link>
                </nav>
                <span class="font-aileron color-light-blue font-size-12 float-right py-0">
                {{ Lang.get('employeedashboard::shared.layout.footer.copyright') }}
                </span>
            </div>
        </footer>
    </main>
</template>

<script>
import TopNav from "@/Shared/TopNav";
import DemoBar from '@/Shared/DemoBar';
import OpenOrderBar from "@/Shared/OpenOrderBar";
import SearchProfileModal from "@/Shared/SearchProfileModal";

export default {
    components: {
        SearchProfileModal,
        OpenOrderBar,
        TopNav,
        DemoBar
    },
    props: {
        title: {
            type: String,
            default() {
                return this.$page.props.auth.user.fullname;
            }
        },
        mainClass: {
            type: String,
            default() {
                return 'background-order-process';
            }
        },
        containerized: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        title: {
            immediate: true,
            handler(title) {
                document.title = title
            },
        },
    },
    methods: {
        url() {
            return location.href;
        },
        isUrl(...urls) {
            if (urls[0] === '') {
                return this.url === ''
            }
            return urls.filter(url => this.url().startsWith(url)).length;
        },
    },
    mounted () {
        document.body.classList.remove('employee-login')
        document.body.classList.remove('background-company')
    },
    destroyed () {
        document.body.classList.add('employee-login')
        document.body.classList.add('background-company')
    }
}
</script>
